import {PureComponent} from 'react'
import scrollToElement from '../../services/scrollTo.js'

import DefaultLayout from '../Layout/DefaultLayout.jsx'
import Header from '../../components/Header/Header.jsx'
import OurVideosItem from './OurVideosItem.jsx'
import headerImg from './note.jpg'
import videosData from "./videos.json"

import './OurVideos.scss'

const headerTitle = "Vidéos Twineeds : tout savoir pour se lancer"
const headerBrief = <p>
  Que vous soyez en <strong>CDI</strong>, en <strong>CDD</strong> ou déjà <strong>indépendant(e)</strong>, ces vidéos vous apportent des réponses
  concrètes aux questions que vous vous posez avant de démarrer avec Twineeds: <strong>statuts, inscription, portage salarial, TJM, visibilité des
  profils, accompagnement, délais pour décrocher une mission...</strong> nous abordons tout ce qu'il faut savoir, selon votre situation, pour avancer
  efficacement avec Twineeds.<br /><br />Sélectionnez votre situation ci-dessous pour afficher le contenu adapté.
</p>

export default class OurVideos extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      currentPlayingId: null,
    }
  }

  componentDidMount() {
    scrollToElement(this.props.location.hash)
  }

  handlePlay = (videoId) => {
    this.setState({ currentPlayingId: videoId })
  }

  handlePause = (videoId) => {
    if (this.state.currentPlayingId === videoId) {
      this.setState({ currentPlayingId: null })
    }
  }

  render() {
    const helmet = {
      title: "Twineeds | Nos vidéos",
      description: "Des vidéos qui vous apportent des réponses concrètes aux questions que vous vous posez avant de démarrer avec Twineeds."
    }

    return (
      <DefaultLayout showSidebarMenu={false} className={`our-videos`} helmet={helmet}>
        <Header
          brief={headerBrief}
          imageAlt="Consultant Twineeds qui prend note"
          imageSrc={headerImg}
          title={headerTitle}
        />

        { videosData.length ? videosData.map((item, index) => item.videos.length ? (
          <OurVideosItem
            key={item.id}
            item={item}
            index={index}
            currentPlayingId={this.state.currentPlayingId}
            handlePlay={this.handlePlay}
            handlePause={this.handlePause}
          />
        ) : null ) : null }
      </DefaultLayout>
    )
  }
}
